var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"fullpage",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"fullpage__container",attrs:{"xs":22,"sm":18,"md":12,"lg":6}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }